// extracted by mini-css-extract-plugin
module.exports = {"label":"ColorPicker_label__32Z0U","checkboxWrapper":"ColorPicker_checkboxWrapper__2e-0D","checkbox":"ColorPicker_checkbox__2Bdeo"};